import Vue from 'vue'
import App from './App.vue'
import moment from 'moment'
import router from '@/router/router'
import '@/style/common.less'
import topChat from '@/utils/topchat'
import '@/style/animate.css'
// import 'vant/lib/index.css';
import { MessagePlugin} from '@/Plugins/plugin.js'
import components from './utils/components'
import { CopyText ,openChatRouter,getUserInfo,detectDeviceType} from '@/utils/utils'
import VueCookie from 'vue-cookie'
import https from '@/utils/http'
import api from '@/api/index'
import '@/utils/rem'
import store from '@/store/store'
import '@/utils/ant'
// import 'ant-design-vue/dist/antd.css'
import hevueImgPreview from 'hevue-img-preview'
import VueLazyload from 'vue-lazyload'

import { Toast } from 'vant';



Vue.config.productionTip = false;
Vue.prototype.moment = moment;
Vue.prototype.topChat = topChat;
Vue.prototype.CopyText = CopyText;
Vue.prototype.$openChatRouter = openChatRouter;  // 路由跳转
Vue.prototype.$https = https;
Vue.prototype.$api = api;
Vue.prototype.getUserInfo = getUserInfo;
Vue.prototype.detectDeviceType = detectDeviceType();

// Vue.use(MessagePlugin)
Vue.use(components)
Vue.use(VueCookie)
Vue.use(hevueImgPreview)
Vue.use(Toast)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('@/assets/svg/img-error.png'),
  loading: require('@/assets/svg/chatLazy.png'),
  attempt: 3
})
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
